var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HubPlace } from '../../../models/hub/hub.place';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { AlertifyService } from '../../../services/alertify.service';
import { PlaceService } from '../../../services/place.service';
import { ToggleAndDataSourceStore } from '../../../stores/hub.calendar.store';
import { EditPlaceImagesModalActions } from './edit.place.images.modal.provider';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { ModalService } from '../../../common/services/modal.service';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { clone, isEmptyArray } from '../../../common/extensions';
import { config } from '../../../../config/config';
import { InputModalComponent } from "../../../common/components/input.modal/input.modal.component";
import { InputModalActions, InputModalData } from "../../../common/components/input.modal/input.modal.provider";
var EditPlaceImagesModalComponent = /** @class */ (function (_super) {
    __extends(EditPlaceImagesModalComponent, _super);
    function EditPlaceImagesModalComponent(dialogRef, actions, hubApiService, imageService, alertify, modalService, toggleAndDataSourceStore, formBuilder, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.formBuilder = formBuilder;
        _this.isGoogleInfoLoaded = false;
        _this.isDragging = false;
        _this.dragFrom = '';
        _this.dropTargets = [];
        _this.coverImage = '';
        _this.publishedImages = [];
        _this.compensateForPublished = [];
        _this.availableImages = [];
        _this.compensateForAvailable = [];
        _this.ownedImages = [];
        _this.compensateForOwned = [];
        _this.googleKey = '';
        _this.totalImageCount = 10;
        _this.totalImageCountThatSysAdminSet = 10;
        _this.useFirstImgAsCover = true;
        _this.place = Object.assign({}, data);
        _this.hubName = _this.place.hubName;
        _this.toggleAndDataSourceStore.toggleAndDataSourceCommand
            .takeUntil(_this.isDestroyed)
            .subscribe(function (command) {
            if (command && command.dataSource.placeImagesShownCount) {
                _this.totalImageCountThatSysAdminSet = command.dataSource.placeImagesShownCount;
            }
            _this.getGooglePlaceAdditionalData();
        });
        return _this;
    }
    EditPlaceImagesModalComponent.prototype.getGooglePlaceAdditionalData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.place.socialName !== 'google') {
                            return [2 /*return*/];
                        }
                        if (!(isEmptyArray(this.place.allowedGooglePhotos) ||
                            this.place.allowedGooglePhotos.any(function (x) { return !x.includes('amazonaws'); }) ||
                            (!isEmptyArray(this.place.blockedGooglePhotos) &&
                                this.place.blockedGooglePhotos.any(function (x) { return !x.includes('amazonaws'); })))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateImages(false)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.buildImages();
                        this.compensate();
                        this.isGoogleInfoLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    EditPlaceImagesModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.publishedImages.length) {
                            event.immediateComplete();
                            this.alertify.warning('Please select at least one allowed image');
                            return [2 /*return*/];
                        }
                        if (!this.place.cover)
                            this.place.cover = { source: '', isDefault: false };
                        // // if the cover image of this place is not uploaded by user, then use the first allowed image as cover
                        // if (!this.place.cover.source.includes('iti-user-upload/')) {
                        //   this.place.cover.source = this.publishedImages[0];
                        // } else
                        // {
                        //   // if the cover image is from a one of the client uploaded own images in this modal, then it should be covered by the first allowed image
                        //   if (
                        //     this.publishedImages.any((x) => x === this.place.cover.source) ||
                        //     this.availableImages.any((x) => x === this.place.cover.source) ||
                        //     this.ownedImages.any((x) => x.url === this.place.cover.source)
                        //   ) {
                        //     this.place.cover.source = this.publishedImages[0];
                        //   }
                        // }
                        // now use the first image from publishedImages as the cover image, as the cover image is now put in the publishedImages initially
                        this.coverImage = this.publishedImages[0];
                        // for client uploaded cover image, it will be re-added in buildImages() when opening this popup
                        if (this.isClientUploaded(this.publishedImages[0])) {
                            this.publishedImages.shift();
                        }
                        this.place.allowedGooglePhotos = this.publishedImages;
                        this.place.blockedGooglePhotos = this.availableImages;
                        return [4 /*yield*/, this.uploadOwnedImagesToAWS()];
                    case 1:
                        _b.sent();
                        if (this.ownedImages && this.ownedImages.any(function (img) { return img.status === 'failed'; })) {
                            event.immediateComplete();
                            return [2 /*return*/];
                        }
                        this.place.ownedPhotos = this.ownedImages.map(function (x) { return x.url; });
                        // to let users see the last image uploaded successfully
                        _a = this.ownedImages.any(function (x) { return x.status === 'uploaded'; });
                        if (!_a) 
                        // to let users see the last image uploaded successfully
                        return [3 /*break*/, 3];
                        return [4 /*yield*/, this.myWait(1000)];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        // to let users see the last image uploaded successfully
                        _a;
                        event.immediateComplete();
                        this.actions.confirm(event, this.place, this.coverImage);
                        this.dialogRef.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    EditPlaceImagesModalComponent.prototype.uploadOwnedImagesToAWS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _loop_1, this_1, _i, _a, img;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _loop_1 = function (img) {
                            var res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (img.url.includes('amazonaws'))
                                            return [2 /*return*/, "continue"];
                                        img.status = 'uploading';
                                        return [4 /*yield*/, this_1.hubApiService.uploadBase64ImageToAWS(img.url, config.compressImgWidth, 'places/iti-user-upload/')];
                                    case 1:
                                        res = _a.sent();
                                        if (res.success) {
                                            img.url = res.url;
                                            img.status = 'uploaded';
                                            setTimeout(function () {
                                                img.status = 'done';
                                            }, 3000);
                                        }
                                        else {
                                            img.status = 'failed';
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, _a = this.ownedImages;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        img = _a[_i];
                        return [5 /*yield**/, _loop_1(img)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EditPlaceImagesModalComponent.prototype.removeOwnImage = function (index) {
        this.ownedImages.splice(index, 1);
    };
    EditPlaceImagesModalComponent.prototype.getImage = function (imgUrl, isRealReference) {
        if (isRealReference === void 0) { isRealReference = true; }
        if (imgUrl.startsWith('http') || imgUrl.startsWith('data:')) {
            return imgUrl;
        }
        var url = PlaceService.getGooglePlaceImageFullUrl(imgUrl, this.googleKey, isRealReference);
        return this.imageService.imageSourceUrl(url);
    };
    EditPlaceImagesModalComponent.prototype.dragEnter = function ($event) {
        if ($event && $event.currentTarget) {
            this.restoreItemStyle();
            $event.currentTarget.style.border = '2px dashed green';
            if (!this.dropTargets.any(function (x) { return x === $event.currentTarget; })) {
                this.dropTargets.push($event.currentTarget);
            }
        }
    };
    EditPlaceImagesModalComponent.prototype.startDrag = function ($event, from) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.isWaitingForUpload($event.srcElement.currentSrc))
                    return [2 /*return*/];
                if (!this.isDragging) {
                    this.isDragging = true;
                    this.dragFrom = from;
                }
                return [2 /*return*/];
            });
        });
    };
    EditPlaceImagesModalComponent.prototype.onItemDrop = function (e, to, index) {
        if (index === void 0) { index = -1; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var photoReference_1, dragDataIndex, temp, dragDataIndex, temp, temp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.restoreItemStyle();
                        if (!(this.dragFrom === 'owned')) return [3 /*break*/, 2];
                        if (!this.ownedImages.any(function (x) { return _this.isWaitingForUpload(x.url); })) return [3 /*break*/, 2];
                        this.alertify.warning('Please wait for uploading, and move the image again.');
                        return [4 /*yield*/, this.uploadOwnedImagesToAWS()];
                    case 1:
                        _a.sent();
                        this.isDragging = false;
                        return [2 /*return*/];
                    case 2:
                        if (e.dragData) {
                            photoReference_1 = PlaceService.getGooglePlaceReference(e.dragData);
                            // drag from allowed list to blocked list
                            if (this.dragFrom === 'allowed' && to === 'blocked') {
                                // client uploaded image or just selected image (not uploaded yet) won't be able to move to blocked/available list
                                if (this.isClientUploaded(photoReference_1)) {
                                    this.removeOwnedImageFromAllowed(photoReference_1);
                                    if (!this.ownedImages.any(function (x) { return x.url === photoReference_1; })) {
                                        this.ownedImages.push({ url: photoReference_1, status: 'initial' });
                                    }
                                }
                                else {
                                    this.publishedImages = this.publishedImages.filter(function (x) { return x !== photoReference_1; });
                                    if (!this.availableImages.any(function (x) { return x === photoReference_1; })) {
                                        this.availableImages.push(photoReference_1);
                                    }
                                }
                            }
                            // drag from blocked list to allowed list
                            if (this.dragFrom === 'blocked' && to === 'allowed') {
                                if (!this.publishedImages.any(function (x) { return x === photoReference_1; })) {
                                    dragDataIndex = this.availableImages.indexOf(photoReference_1);
                                    // replace an allowed image
                                    if (index >= 0) {
                                        temp = this.publishedImages[index];
                                        this.publishedImages[index] = photoReference_1;
                                        !this.isClientUploaded(temp) &&
                                            !this.isWaitingForUpload(temp) &&
                                            (this.availableImages[dragDataIndex] = temp);
                                    }
                                    else {
                                        // add to the end of the allowed list
                                        this.publishedImages.push(photoReference_1);
                                    }
                                    this.availableImages = this.availableImages.filter(function (x) { return x !== photoReference_1; });
                                }
                            }
                            if (this.dragFrom === 'allowed' && to === 'allowed') {
                                if (index === -1) {
                                    this.isDragging = false;
                                    return [2 /*return*/];
                                }
                                dragDataIndex = this.publishedImages.indexOf(photoReference_1);
                                temp = this.publishedImages[index];
                                this.publishedImages[index] = photoReference_1;
                                this.publishedImages[dragDataIndex] = temp;
                            }
                            if (this.dragFrom === 'owned' && to === 'allowed') {
                                if (!this.publishedImages.any(function (x) { return x === photoReference_1; })) {
                                    // replace an allowed image
                                    if (index >= 0 && index <= this.publishedImages.length) {
                                        temp = this.publishedImages[index];
                                        this.publishedImages[index] = photoReference_1;
                                        !this.isClientUploaded(temp) && !this.isWaitingForUpload(temp) && this.availableImages.push(temp);
                                    }
                                    else {
                                        // add to the end of the allowed list
                                        this.publishedImages.push(photoReference_1);
                                    }
                                }
                                else {
                                    this.alertify.warning('This image is already added');
                                }
                            }
                            if (this.dragFrom === 'owned' && to === 'blocked') {
                                this.alertify.warning("You can't add this image to this list");
                            }
                            this.compensate();
                        }
                        this.isDragging = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    EditPlaceImagesModalComponent.prototype.removeOwnedImageFromAllowed = function (image) {
        this.publishedImages = this.publishedImages.filter(function (x) { return x !== image; });
        this.compensate();
    };
    EditPlaceImagesModalComponent.prototype.isClientUploaded = function (image) {
        return image.includes('iti-user-upload');
    };
    EditPlaceImagesModalComponent.prototype.isWaitingForUpload = function (image) {
        if (!image)
            return false;
        return !image.includes('amazonaws');
    };
    EditPlaceImagesModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    EditPlaceImagesModalComponent.prototype.updateImages = function (isAskForConfirm) {
        if (isAskForConfirm === void 0) { isAskForConfirm = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var run, actions, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        run = function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, allPhotos, realReferences;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        this.isGoogleInfoLoaded = false;
                                        _a = this;
                                        return [4 /*yield*/, PlaceService.getGooglePlaceDetails(this.place, this.hubName, this.hubApiService, true)];
                                    case 1:
                                        _a.googlePlaceAdditionalData = _b.sent();
                                        if (!this.googlePlaceAdditionalData) {
                                            this.alertify.warning('This Google place has no photos');
                                            this.close();
                                        }
                                        if (this.googlePlaceAdditionalData.allowedGooglePhotos) {
                                            allPhotos = this.googlePlaceAdditionalData.allowedGooglePhotos;
                                            this.googleKey = this.googlePlaceAdditionalData.appKey;
                                            realReferences = allPhotos.map(function (x) { return PlaceService.getGooglePlaceReference(x); });
                                            this.place.allowedGooglePhotos = realReferences;
                                            this.place.blockedGooglePhotos = isAskForConfirm ? [] : this.googlePlaceAdditionalData.blockedGooglePhotos;
                                        }
                                        if (this.place.cover && this.place.cover.source) {
                                            this.place.cover.source = this.imageService.imageSource(this.place);
                                        }
                                        this.buildImages();
                                        this.compensate();
                                        this.isGoogleInfoLoaded = true;
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        if (!isAskForConfirm) return [3 /*break*/, 1];
                        actions = {
                            confirm: function (event) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            event.complete();
                                            return [4 /*yield*/, run()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                        };
                        data = {
                            confirmModalIcon: 'warning',
                            confirmModalTitle: 'Alert',
                            confirmModalDescription: 'Are you sure you want to update Google images of this place, this will refresh all Google images and reset them to allowed status?',
                            confirmModalConfirmButtonText: 'Yes',
                            confirmModalCancelButtonText: 'Cancel',
                            isAsync: true,
                        };
                        this.modalService.show({
                            component: ConfirmModalComponent,
                            providers: [
                                { provide: ConfirmModalActions, useValue: actions },
                                { provide: ConfirmModalData, useValue: data },
                            ],
                        });
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, run()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EditPlaceImagesModalComponent.prototype.enterImageLink = function () {
        var _this = this;
        var actions = {
            confirm: function (event, url) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log(url);
                            this.ownedImages.push({
                                url: url,
                                status: 'initial',
                            });
                            return [4 /*yield*/, this.uploadOwnedImagesToAWS()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
        };
        this.modalService.show({
            component: InputModalComponent,
            providers: [
                { provide: InputModalActions, useValue: actions },
                {
                    provide: InputModalData,
                    useValue: new InputModalData('Enter image link', '', null, 'OK', 'CANCEL', false),
                },
            ],
            panelClass: 'width-modal-2',
        });
    };
    EditPlaceImagesModalComponent.prototype.onImageChange = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var i, selectedImageFiles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ($event.srcElement.files.length > 10 || $event.srcElement.files.length + this.ownedImages.length > 10) {
                            this.alertify.warning("You can't upload more than 10 images");
                        }
                        this.selectedImageFiles = $event.srcElement.files;
                        if (!(this.selectedImageFiles && this.selectedImageFiles.length > 0)) return [3 /*break*/, 6];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.selectedImageFiles.length)) return [3 /*break*/, 4];
                        if (this.ownedImages.length >= 10)
                            return [3 /*break*/, 4];
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(this.selectedImageFiles[i])];
                    case 2:
                        selectedImageFiles = _a.sent();
                        this.ownedImages.push({
                            url: selectedImageFiles,
                            status: 'initial',
                        });
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [4 /*yield*/, this.uploadOwnedImagesToAWS()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        // reset file input
                        $event.srcElement.value = '';
                        return [2 /*return*/];
                }
            });
        });
    };
    EditPlaceImagesModalComponent.prototype.restoreItemStyle = function () {
        this.dropTargets.forEach(function (x) {
            x.style.border = 'none';
        });
    };
    EditPlaceImagesModalComponent.prototype.buildImages = function () {
        this.publishedImages = [];
        this.availableImages = [];
        this.ownedImages = [];
        var hasUserUploadedCoverImage = false;
        var allowedPhotos = clone(this.place.allowedGooglePhotos) || [];
        if (this.place.cover.source) {
            // insert the client uploaded cover image as the first one of the allowed images
            // replace the first one with the cover image if the first one was not client uploaded
            // so that the cover image will always show as the first one in allowed images, and there is no duplicated image issue
            if (this.isClientUploaded(this.place.cover.source)) {
                this.publishedImages.push(this.place.cover.source);
                hasUserUploadedCoverImage = true;
            }
            else {
                allowedPhotos[0] = this.place.cover.source;
            }
        }
        if (this.place.allowedGooglePhotos && this.place.allowedGooglePhotos.length >= 0) {
            var images = this.publishedImages.concat(allowedPhotos);
            this.publishedImages = images.slice(0, this.totalImageCountThatSysAdminSet);
            this.availableImages = allowedPhotos
                .slice(hasUserUploadedCoverImage ? this.totalImageCountThatSysAdminSet - 1 : this.totalImageCountThatSysAdminSet)
                .concat(this.place.blockedGooglePhotos);
        }
        if (this.place.ownedPhotos && this.place.ownedPhotos.length >= 0) {
            this.ownedImages = this.place.ownedPhotos.map(function (x) {
                return { url: x, status: 'initial' };
            });
        }
    };
    // allowed row and blocked row both show 10 images in a flex div, so here to compensate to make them as 10 if dragged out one
    EditPlaceImagesModalComponent.prototype.compensate = function () {
        if (this.publishedImages && this.publishedImages.length >= 0) {
            this.compensateForPublished = [];
            for (var i = 0; i < this.totalImageCountThatSysAdminSet - this.publishedImages.length; i++) {
                this.compensateForPublished.push({});
            }
        }
        if (this.availableImages && this.availableImages.length >= 0) {
            this.compensateForAvailable = [];
            for (var i = 0; i < this.totalImageCount - this.availableImages.length; i++) {
                this.compensateForAvailable.push({});
            }
        }
        // if (this.ownedImages && this.ownedImages.length >= 0) {
        //   this.compensateForOwned = [];
        //   for (let i = 0; i < this.totalImageCount - this.ownedImages.length; i++) {
        //     this.compensateForOwned.push({});
        //   }
        // }
    };
    EditPlaceImagesModalComponent.prototype.myWait = function (milSeconds) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                resolve(null);
            }, milSeconds);
        });
    };
    return EditPlaceImagesModalComponent;
}(BaseComponent));
export { EditPlaceImagesModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.place.images.modal/edit.place.images.modal.component.ts.pre-build-optimizer.js